// Canonical list of UI / email-preference languages.
// Must stay in sync with i18n.js supportedLngs. Native-name labels are
// shown as-is in every locale (a language menu reads best in its own
// language). Imported by LanguageSwitcher (navbar/drawer), SignUp (org
// language picker on PRO branches), and UserManagement (if needed for
// any future org-language editing).
export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "es", label: "Español", short: "ES" },
  { code: "pt-BR", label: "Português (BR)", short: "PT" },
  { code: "ru", label: "Русский", short: "RU" },
  { code: "tg", label: "Тоҷикӣ", short: "TG" },
  { code: "vi", label: "Tiếng Việt", short: "VI" },
];

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);

// Default fallback when no preference is known. Matches i18n.js fallbackLng.
export const DEFAULT_LANGUAGE = "en";
